import React, { memo } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { faTrophy } from '@fortawesome/pro-solid-svg-icons'

import FaIcon from '../faIcon/FaIcon'
import { AlertTitle } from '@mui/material'
import { NOTIFICATION_CLOSING_TIME } from '../../../constants/app'
import { DEFAULT_BG_COLOR } from '../../theme/Theme-variable'

const CustomSnackbar = ({ open, title, message, onClose }) => {
  return (
    open && (
      <Snackbar
        open
        autoHideDuration={NOTIFICATION_CLOSING_TIME}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={onClose}
          severity='primary'
          variant='outlined'
          sx={{ width: '100%', backgroundColor: DEFAULT_BG_COLOR }}
          icon={<FaIcon icon={faTrophy} />}
        >
          <AlertTitle sx={{ fontWeight: 900, fontSize: '1.125rem' }}>
            {title}
          </AlertTitle>
          {message}
        </Alert>
      </Snackbar>
    )
  )
}

export default memo(CustomSnackbar)
